import { useState } from 'react';

import { UnitSystem } from '@ravago/shared/page-data/models/config';

export const useProductPortfolioPreferences = () => {
   const isBrowser = typeof globalThis.window !== 'undefined';

   const [view, setView] = useState<'grid' | 'list' | undefined>(
      () => (isBrowser ? sessionStorage.getItem('view') || undefined : undefined) as 'grid' | 'list' | undefined
   );
   const [unitSystem, setUnitSystem] = useState<UnitSystem | undefined>(
      () => (isBrowser ? sessionStorage.getItem('unit') || undefined : undefined) as UnitSystem | undefined
   );
   const [columnSelection, setColumnSelection] = useState<string[] | undefined>(() => {
      if (!isBrowser) return undefined;
      const storedColumns = sessionStorage.getItem('columns');
      return storedColumns ? JSON.parse(storedColumns) : undefined;
   });

   const saveView = (newView: 'grid' | 'list') => {
      setView(newView);
      if (isBrowser) sessionStorage.setItem('view', newView);
   };

   const saveUnitSystem = (newUnitSystem: UnitSystem) => {
      setUnitSystem(newUnitSystem);
      if (isBrowser) sessionStorage.setItem('unit', newUnitSystem);
   };

   const saveColumnSelection = (newColumnSelection: string[]) => {
      setColumnSelection(newColumnSelection);
      if (isBrowser) sessionStorage.setItem('columns', JSON.stringify(newColumnSelection));
   };

   return {
      view,
      unitSystem,
      columnSelection,
      saveView,
      saveUnitSystem,
      saveColumnSelection
   };
};
